import { useEffect, useRef, useState } from 'react';
import { DxReportDesigner } from 'devexpress-reporting/dx-reportdesigner';
import * as ko from 'knockout';
import deCore from '../../localization/dx-analytics-core.es.json';
import deRep from '../../localization/dx-reporting.es.json';
import { useAppSelector } from '../../contexts/hooks';
import { setDxReportingAuth } from '../../utils/dxReportingAuth';
import './ConfigReportesDisenador.scss';

const Index = () => {
  const designerRef = useRef<HTMLDivElement>(null);
  const [host, setHost] = useState('');
  const token = useAppSelector((d) => d.userInfo.Token);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetch('/config.json');
        const data = await response.json();
        setHost(`${data.apiUrl}/`);
      } catch (error) {
        console.error('Error fetching config data:', error);
      }
    };
    fetchConfig();
  }, []);

  useEffect(() => {
    if (!designerRef.current || !host) {
      return;
    }

    // Adjunta el JWT a las peticiones del diseñador (el backend ahora exige autenticación).
    setDxReportingAuth(token);

    // Sin reportUrl el diseñador abre en blanco; el usuario usa Nuevo / Abrir desde su barra de herramientas.
    const designer = new DxReportDesigner(designerRef.current, {
      requestOptions: {
        host,
        getDesignerModelAction: 'DXXRD/GetDesignerModel',
      },
      callbacks: {
        CustomizeLocalization: (s: any, e: any) => {
          e.LoadMessages(deCore);
          e.LoadMessages(deRep);
        },
      },
    });

    designer.render();

    return () => {
      try {
        designer.dispose();
        if (designerRef.current) {
          ko.cleanNode(designerRef.current);
          designerRef.current.innerHTML = '';
        }
      } catch (error) {
        console.warn('Error limpiando el diseñador de reportes:', error);
      }
    };
  }, [host, token]);

  return (
    <div className={'view'}>
      <div className='report-designer-wrapper'>
        <div className='report-designer-host'>
          <div ref={designerRef} style={{ width: '100%', height: '100%' }} />
        </div>
      </div>
    </div>
  );
};

export default Index;
